import { navItems } from '@/mocks/homeData';

export default function FooterSection() {
  const scrollTo = (id: string) => {
    const el = document.querySelector(id);
    if (el) el.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <footer id="footer" className="bg-background-900 text-background-200">
      <div className="w-full px-4 md:px-6 max-w-7xl mx-auto py-14 md:py-16">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 md:gap-10">
          <div>
            <div className="flex items-center gap-2 mb-4">
              <span className="w-9 h-9 flex items-center justify-center rounded-lg bg-primary-500">
                <i className="ri-play-circle-fill text-background-50 text-xl"></i>
              </span>
              <span className="font-heading text-xl font-bold text-background-50">香蕉影视</span>
            </div>
            <p className="text-background-400 text-sm leading-relaxed mb-4">
              香蕉影视综艺娱乐免费高清在线观看平台，提供热门最新搞笑综艺大全，高清不缓冲流畅秒开不卡顿，全集免费看轻松看。
            </p>
          </div>

          <div>
            <h3 className="font-heading text-base font-bold text-background-50 mb-4">快速导航</h3>
            <nav className="flex flex-col gap-2">
              {navItems.slice(1).map((item) => (
                <a
                  key={item.href}
                  href={item.href}
                  onClick={(e) => { e.preventDefault(); scrollTo(item.href); }}
                  className="text-background-400 hover:text-primary-400 text-sm transition-colors whitespace-nowrap cursor-pointer"
                >
                  {item.label}
                </a>
              ))}
            </nav>
          </div>

          <div>
            <h3 className="font-heading text-base font-bold text-background-50 mb-4">内容分类</h3>
            <div className="flex flex-col gap-2">
              {['搞笑综艺', '真人秀', '脱口秀', '音乐竞技', '美食探店', '舞蹈比赛'].map((cat) => (
                <a
                  key={cat}
                  href="#cards"
                  onClick={(e) => { e.preventDefault(); scrollTo('#cards'); }}
                  className="text-background-400 hover:text-primary-400 text-sm transition-colors whitespace-nowrap cursor-pointer"
                >
                  {cat}
                </a>
              ))}
            </div>
          </div>

          <div>
            <h3 className="font-heading text-base font-bold text-background-50 mb-4">合作伙伴</h3>
            <p className="text-background-500 text-sm leading-relaxed">
              我们与众多优质内容制作方和播出平台保持密切合作，持续为用户提供丰富多样的综艺娱乐内容。
            </p>
          </div>
        </div>

        <div className="mt-10 pt-8 border-t border-background-700/50 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-background-500 text-xs">
            &copy; 2026 香蕉影视 版权所有 | 综艺娱乐免费高清在线观看
          </p>
          <div className="flex items-center gap-5">
            {[
              { icon: 'ri-wechat-line', label: '微信' },
              { icon: 'ri-weibo-line', label: '微博' },
              { icon: 'ri-bilibili-line', label: 'B站' },
              { icon: 'ri-tiktok-line', label: '抖音' },
            ].map((social) => (
              <a
                key={social.label}
                href="#footer"
                onClick={(e) => e.preventDefault()}
                className="w-8 h-8 flex items-center justify-center rounded-lg text-background-400 hover:text-primary-400 hover:bg-background-800 transition-colors cursor-pointer"
                aria-label={social.label}
                rel="nofollow"
              >
                <i className={`${social.icon} text-lg`}></i>
              </a>
            ))}
          </div>
        </div>
      </div>
    </footer>
  );
}